import React from 'react';
import PropTypes from 'prop-types';

import Cleave from 'cleave.js/react';
import LabeledTextInput from 'components/consumer/LabeledTextInput';

const options = {
  delimiters: ['(', ') ', '-', '-'],
  blocks: [0, 3, 3, 4],
};

const PhoneFieldRaw = ({ ...props }) => (
  <Cleave
    {...props}
    options={options}
    onChange={evt => {
      const { value } = evt.target;
      evt.target.value = value ? value.replace(/[^0-9\s()-]/g, '') : '';
      if (props.onChange) {
        props.onChange(evt);
      }
    }}
  />
);

PhoneFieldRaw.propTypes = {
  onChange: PropTypes.func,
};

const PhoneNumberField = ({
  id = 'phone_number',
  name = 'phone_number',
  placeholder = 'Phone (delivery contact) *',
  value,
  error,
  isTouched,
  handleChange,
  handleBlur,
  updateShipping,
  isRequired = true,
  ...props
}) => (
  <LabeledTextInput
    id={id}
    name={name}
    component={PhoneFieldRaw}
    type="tel"
    value={value}
    label={placeholder}
    data-xc="shipping-phoneNumber-field"
    onChange={handleChange}
    autoComplete="tel"
    onBlur={evt => {
      handleBlur(evt);
      if (!error && updateShipping) {
        updateShipping();
      }
    }}
    required={isRequired ? '' : undefined}
    aria-required={isRequired ? '' : undefined}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    errorMessage={isTouched && error ? error : null}
  />
);

PhoneNumberField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  updateShipping: PropTypes.func,
  value: PropTypes.string,
};

export default PhoneNumberField;
